<template>
  <NBox class="flex items-center w-full p-3 my-2 overflow-hidden">
    <NText
      weight="bold"
      variant="caption1"
      class="text-neutral-secondary ml-2 flex-shrink-0"
    >
      {{ t('orders.valid_until') }} :
    </NText>

    <NCheap
      v-for="(item, index) in CONDITIONAL_ORDER_VALIDITY_TIME_PERIOD"
      :key="index"
      :model-value="item.value"
      selectable
      :closable="false"
      class="flex-1 items-center justify-center ml-1 whitespace-nowrap px-1 cursor-pointer"
      size="small"
      :label="item.label"
      :color="modelValue === item.value ? 'green' : 'gray'"
      @click="emit('update:modelValue', item.value)"
    />
  </NBox>
</template>

<script setup lang="ts">
import { CONDITIONAL_ORDER_VALIDITY_TIME_PERIOD } from '@core/order';
import { useI18n } from 'vue-i18n';

type ConditionalValidityProps = {
  modelValue: number;
};

type ConditionalValidityEmits = {
  (e: 'update:modelValue', value: number): void;
};

defineProps<ConditionalValidityProps>();
const emit = defineEmits<ConditionalValidityEmits>();

const { t } = useI18n();
</script>
